import {Component, Input, input, OnInit} from '@angular/core';

import {RadioButtonModule} from "primeng/radiobutton";
import {ProjectProfileGroup} from "../../../../../api/db/entities/ProjectProfileGroup";
import {ProjectDescriptor, ProjectDescriptorCategory} from "../../../../../api/project_schemas";
import {ProjectProfileSelection} from "../../../../../api/db/entities/ProjectProfileSelection";
import {TooltipModule} from "primeng/tooltip";
import {CheckboxModule} from "primeng/checkbox";
import {FormsModule} from "@angular/forms";
import {AbstractProfileComponent} from "../abstract-profile.component";

@Component({
    selector: 'profile-radio-button',
    imports: [
    RadioButtonModule,
    TooltipModule,
    CheckboxModule,
    FormsModule
],
    templateUrl: './profile-radio-button.component.html',
    styleUrl: './profile-radio-button.component.scss'
})
export class ProfileRadioButtonComponent extends AbstractProfileComponent implements OnInit {

    protected selected: string;

    constructor() {
        super();
        //this.selected = this.profileGroup().profileSelections.find(s => s.value === 'true')?.descriptorUniqueId;
    }

  

    selectOption(selection: string) {
        for (const s of this.profileGroup().profileSelections) {
            if (s.categoryUniqueId === this.holder.categoryUniqueId) {
                s.value = (s.descriptorUniqueId === selection ? 'true' : 'false'); 
            }
        }
        //this.selected = selection;
    }

}
